import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { pntSegmentsControllerSegmentsSimpleSearch } from '@mi-front/api-v2';
import { toDateTimeStr } from '@mi-front/core';
import moment from 'moment';
import { ReportView } from '../../../../core/reports/components/ReportView';
import { ElasticSearchReport } from '../../types';
import { SearchForm } from './components/form/SearchForm';
import { SearchResult } from './components/result/SearchResult';

interface Props {
  station: Station;
}

/**
 * Station transcription search report; fetches via api-v2 PNT simple-search.
 */
export function SearchView(p: Props) {
  const { station } = p;
  const tz = useTimezone();

  return (
    <ReportView<ElasticSearchReport>
      defaultValues={{
        from: toDateTimeStr(moment().tz(tz).startOf('day').toISOString()),
        to: toDateTimeStr(moment().tz(tz).endOf('day').toISOString()),
        input: '',
        pageSize: 50,
        pageIndex: 0,
      }}
      download={false}
      queryParamsTransform={{}}
      reportFn={async (values) => {
        return (await pntSegmentsControllerSegmentsSimpleSearch(station.slug, {
          query: values.input,
          from: values.from,
          to: values.to,
          groupByLength: 60,
        })) as unknown as ElasticSearchReport['Result'];
      }}
      Form={SearchForm}
      Result={SearchResult}
    />
  );
}
